export const SUPPORTED_VIDEO_CODECS = ['h264'];
